import styled from 'styled-components'

export const IconTextWrapper = styled.div`
  width: 300px;
  margin: 16px 0;
  display: flex;
  align-items: center;

  img {
    margin-right: 16px;
  }

  > div {
    flex-wrap: nowrap;
  }
`
